import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Dropdown, Space } from "antd";
import { IoMdArrowDropdown } from "react-icons/io";
import { useSelector } from "react-redux";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ period, onPeriodChange, labels, values, totalOrders }) => {
  const { is_admin } = useSelector((state) => state.auth);
  const fetchFreq = is_admin
    ? {
        active: "Active",
        inactive: "Inactive",
      }
    : {
        daily: "today",
        weekly: "this week",
        monthly: "this month",
        yearly: "this year",
      };

  const items = is_admin
    ? [
        {
          label: "Active",
          key: "active",
        },
        {
          label: "Inactive",
          key: "inactive",
        },
      ]
    : [
        { label: "Daily", key: "daily" },
        { label: "Weekly", key: "weekly" },
        { label: "Monthly", key: "monthly" },
        { label: "Yearly", key: "yearly" },
      ];

  const chartData = {
    labels,
    datasets: [
      {
        label: is_admin ? "Users" : "Orders",
        data: values,
        backgroundColor: "#413B53",
        borderRadius: { topLeft: 20, topRight: 20 },
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false }, title: { display: false } },
    scales: {
      x: { grid: { display: false } },
      y: {
        border: { display: false },
        grid: { color: "#ddd" },
        ticks: {
          beginAtZero: true,
          stepSize: values.length > 0 ? Math.ceil(Math.max(...values) / 5) : 1,
          maxTicksLimit: 6,
        },
      },
    },
  };

  return (
    <>
      <div className="flex justify-between items-start w-full">
        {/* Left Content */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-4">
            <div className="w-[45px] h-[45px] bg-[#A334341A] flex justify-center items-center rounded-xl">
              <img src="../../../assets/icons/sales.png" alt="card-logo" />
            </div>
            <p className="text-xl break-words whitespace-normal">Sales Summary</p>
          </div>

          <div className="flex items-center gap-4">
            <p className="text-6xl">{totalOrders}</p>
            {is_admin ? (
              <p className="text-lg break-words whitespace-normal text-start">
                Total {fetchFreq[period]} <br /> Users
              </p>
            ) : (
              <p className="text-lg break-words whitespace-normal text-start">
                Orders placed <br /> {fetchFreq[period]}
              </p>
            )}
          </div>
        </div>

        {/* Right Dropdown */}
        <div className="flex items-center">
          <Dropdown
            menu={{ items, onClick: (e) => onPeriodChange(e.key) }}
            placement="bottomRight"
            className="border border-[#D9D9D9] p-3 rounded-2xl hover:text-[#8B0A1A]"
          >
            <a
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-2 font-bold text-base"
            >
              <Space>
                {period.charAt(0).toUpperCase() + period.slice(1)}
                <IoMdArrowDropdown className="text-xl" />
              </Space>
            </a>
          </Dropdown>
        </div>
      </div>

      {/* Chart */}
      <div className="pt-8 h-[300px] md:h-[350px]">
        <Bar data={chartData} options={options} />
      </div>
    </>
  );
};

export default BarChart;
